import React from 'react';
import PropTypes from 'prop-types';

const FormQuestion = ({
  label, isRequired, hint, children, colspan, className,
}) => (
  <div className={`sm:col-span-${colspan} flex flex-col justify-between py-3 ${className}`}>
    <label className="block text-sm font-semibold text-gray-700">
      {label}
      {isRequired && (
        <sup className="text-red-regular">*</sup>
      )}
    </label>
    {hint && (
      <p className="text-xs text-gray-500 mb-2">{hint}</p>
    )}
    <div className="mt-1">
      {children}
    </div>
  </div>
);

FormQuestion.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isRequired: PropTypes.bool,
  hint: PropTypes.string,
  colspan: PropTypes.number,
  className: PropTypes.string,
};

FormQuestion.defaultProps = {
  isRequired: false,
  hint: '',
  colspan: 6,
  className: '',
};

export default FormQuestion;
